var path = 'areas/projects/variables/project_variables_all.html';
var html = "<div> <script octo-section=project_tools_left type=text/ng-template> <spin active='isSaving.busy'></spin> </script> <script octo-section=project_tools type=text/ng-template> <button class=\"btn btn-success\" ng-show=\"canSave || canSaveProject\" ng-disabled=\"isSaving.busy || isLoading.busy\" ng-click=\"save()\">Save</button> </script> <h3>All Variables</h3> <variable-editor class=slick-grid-container-box data=variableEditorOptions ng-show=showVariableEditor></variable-editor> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_all.html
// module id = 3928806549021383
// module chunks = 1